import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const countryReducer = createReducer(initialState)({
    [types.COUNTRY_DROPDOWN]: (state, action) => ({
        ...state,
        country_dropdown: action.payload
    })
});

export default countryReducer;